import styled from "styled-components";

export const PerguntasFrequentesContainer = styled.div`
  margin-top: 15px;
  background-color: #f4f5f5;
`;
export const PerguntasFrequentesContainerText = styled.div`
  font-family: Akrobat;
  background-color: #820ad1;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const PerguntasFrequentesContainerContent = styled.div`
  width: 1000px;
  height: auto;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
`;
export const PerguntasFrequentesContainerContentHeader = styled.div`
  width: 100%;
  height: 60px;
  position: relative;
`;
export const PerguntasFrequentesContainerContentHeaderContent = styled.div`
  width: 42%;
  height: 100%;
  margin-top: 1rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const GridContainer = styled.div`
  width: 100%;
  min-height: 300px;
  position: relative;
  margin-top: 1rem;
`;
export const GridCard = styled.div`
  width: 100%;
  height: 80px;
  position: relative;
  background-color: white;
  border-radius: 5px;
  box-shadow: 2px 2px 5px 2px gray;
  margin-bottom: 1rem;
`;
export const GridCardHeader = styled.div`
  width: 95%;
  height: 72px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
`;
export const GridCardHeaderTitle = styled.div`
  width: 90%;
  height: 100%;
  position: relative;
  // background-color: cadetblue;
  display: flex;
  align-items: center;
  p {
    font-size: 22px;
    font-family: "Akrobat SemiBold";
    color: rgb(40, 40, 40);
  }
`;
export const GridCardHeaderControl = styled.div`
  width: 5%;
  height: 100%;
  position: relative;
  // background-color: rgb(100, 160, 95);
  display: flex;
  align-items: center;
  cursor: pointer;
`;
export const GridCardBody = styled.div`
  width: 95%;
  height: auto;
  min-height: 200px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  p {
    font-size: 18px;
    font-family: "Akrobat";
    color: rgb(61, 61, 61);
    text-align: justify;
  }
`;
